<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="标签名称：" prop="name">
            <el-input v-model="searchForm.name" placeholder="标签名称搜索" class="mt-search-width"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button @click="toAdd('')" size="small" type="primary" class="bg-theme">添加标签</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="label"
            label="标签名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1" class="mt-green">开启</span>
              <span v-else class="mt-red">禁用</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="updateTime"
            label="更新时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="toAdd(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <el-dialog
      title="添加标签"
      :visible.sync="dialogVisible"
      width="960px">
      <el-form :model="cateForm" :rules="cateRules" label-width="140px">
        <el-form-item label="标签名称：" prop="name">
          <el-input style="width: 420px;" v-model="cateForm.name" placeholder="请输入标签名称"></el-input>
        </el-form-item>
        <el-form-item label="是否开启：" prop="status">
          <el-switch
            v-model="cateForm.status"
            active-color="#1890FF"
            inactive-color="#CCCCCC">
          </el-switch>
        </el-form-item>
        <el-form-item label="排序：" prop="sort">
          <el-input style="width: 420px;" v-model="cateForm.sort" placeholder="请输入排序(默认1)"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { goodsTagList, goodsTagDel,goodsTagAdd,goodsTagEdit,goodsTagInfo } from '@/api/goodsTag'
export default {
  name: 'Goods_tag',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      },
      // 一级分类数据
      dataId:'',
      dialogVisible: false,
      cateForm:{
        name:'',
        status:true,
        sort:''
      },
      cateRules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      goodsTagList({ label: searchName,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        goodsTagDel({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    /* 跳转添加 */
    toAdd (dataId) {
      this.dataId = dataId
      if(dataId != ''){
        let that = this
        goodsTagInfo({ id: dataId }).then((res) => {
          if (res.errorCode === '0000') {
            let data = res.data
            that.cateForm.name = data.label
            that.cateForm.status = data.status == 1 ? true : false
            that.cateForm.sort = data.sort
          }
        })
      }
      this.dialogVisible = true
    },
    // 添加-编辑
    saveBtn(){
      var that = this
      var dataId = that.dataId
      var name = that.cateForm.name
      var status = that.cateForm.status ? 1 : 0
      var sort = that.cateForm.sort
      if (name === '') {
        this.$message.error('请输入标签名称')
        return false
      }
      let passData = {
        label: name, status: status, sort: sort
      }
      if (dataId !== '') {
        passData = {
          id: dataId,label: name, status: status, sort: sort
        }
        goodsTagEdit(passData).then((res) => {
          that.fullscreenLoading = false;
          that.dialogVisible=false;
          that.currentPage = 1;
          that.getInfoList();
        })
      }else{
        goodsTagAdd(passData).then((res) => {
          that.fullscreenLoading = false;
          that.cateForm.name = '';
          that.cateForm.sort = '';
          that.dialogVisible=false;
          that.currentPage = 1;
          that.getInfoList();
        })
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/goods/Tag.vue